import apiClient from "./apiClient";

// REGISTER CLIENT + USER
export const registerClient = async (payload) => {
    try {
        const response = await apiClient.post("/register", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// GET BY ID
export const getClientById = async (id) => {
    try {
        const response = await apiClient.get(`/getById/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// GET ALL CLIENTS
export const getAllClients = async (page = 1) => {
    try {
        const response = await apiClient.get(`/getallclient?page=${page}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// UPDATE CLIENT (Assuming PUT API exists like /update/{id})
export const updateClient = async (id, payload) => {
    try {
        const response = await apiClient.put(`/update/${id}`, payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// TOGGLE CLIENT ACTIVE / INACTIVE
export const toggleClientStatus = async (id) => {
    try {
        const response = await apiClient.post(`/client_active_inactive/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};